import { render } from "./movieRating.vue?vue&type=template&id=3d7decfe"
import script from "./movieRating.vue?vue&type=script&lang=js"
export * from "./movieRating.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__